// engine
import { ArController, gameDispatcher } from '@aceroll/core';

// library
import { slotDispatcher } from '@aceroll/core/library';

// hacksaw
import { responseService } from '@aceroll/platform-hacksaw';

// services
import { respinService } from '../../services/respin-service';
import { winAnimationService } from '../../services/win-animation-service';

export class EvRespin extends ArController {
	async onStart() {
		const { gameType } = gameDispatcher.state;

		if (!respinService.started) {
			respinService.start();
		}

		const { slotMachine } = this.context.currentLayout;

		// userDispatcher.setTempMode(SPECIAL_SPIN_MODE);
		await slotMachine.spin();

		const serverEvent = responseService.getEvent();
		// console.log('serverEvent', serverEvent);
		const { symbols } = serverEvent.data;
		slotDispatcher.updateSymbols(symbols, gameType, []);
		await slotMachine.stop();
		// userDispatcher.clearTempMode();

		//TODO show winnings
		await winAnimationService.playEvent(serverEvent);

		responseService.completeEvent();
		this.stop();
	}
}
